module.exports = __webpack_public_path__ + "static/media/banner.2f63afba.jpg";